import React from 'react'
import { useDispatch } from 'react-redux'
import notificationLogo from '@/assets/images/notification.png'
import { selectedFieldHC } from '@/store/clinicHistoryField/actions'

import s from './styles.module.scss'

const ContentSideBar = ({ listItem }) => {
  const dispatch = useDispatch()

  return (
    <div>
      {!listItem?.length ? (
        <p className={s.emptyList}>No hay campos de HC cargados aún</p>
      ) : (
        listItem?.map((item) => (
          <div key={item._id} className={s.item} onClick={async () => await dispatch(selectedFieldHC(item))}>
            <img src={notificationLogo} alt="campos de HC" />
            <div className={s.containerInfoService}>
              <p>
                <span className={s.bold}>Nombre: </span> <span> {item?.name}</span>
              </p>
              <p>
                <span className={s.bold}>Id: </span>
                <span>{item?._id}</span>
              </p>
              <p>
                <span className={s.bold}>Tipo: </span> <span>{item?.type}</span>
              </p>
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default ContentSideBar
